import { useQuery } from "@tanstack/react-query";
import { queries } from "@core-shop/cache";
import { LocationSearchVariables } from "@core-shop/types";

export function useLocationSearch(vars: LocationSearchVariables) {
  return useQuery(queries.locationSearch(vars));
}
